/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Times_NoteInputs */

const en_apartment_times_note = /** @type {(inputs: Apartment_Times_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local time in Belgrade.`)
};

/**
* | output |
* | --- |
* | "Local time in Belgrade." |
*
* @param {Apartment_Times_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_times_note = /** @type {((inputs?: Apartment_Times_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Times_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_times_note(inputs)
});